/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";

// Define SortableItem with manual drag-and-drop functionality
const SortableItem = ({
  imageObj,
  index,
  onDelete,
  onAddCaption,
  onDragStart,
  onDragEnter,
  onDragEnd,
}) => {
  const fileName = imageObj?.file.name;
  const fileExtension = fileName ? fileName.split(".").pop() : "";
  return (
    <div
      className="relative m-2 inline-block h-56 w-full cursor-grab overflow-hidden rounded-lg bg-gray-100 p-2 shadow-md transition-transform duration-300 md:w-56"
      draggable
      onDragStart={() => onDragStart(index)}
      onDragEnter={() => onDragEnter(index)}
      onDragEnd={onDragEnd}
    >
      {imageObj?.file && (
        <img
          src={
            typeof imageObj?.file === "object"
              ? URL.createObjectURL(imageObj.file)
              : imageObj?.file
          }
          alt="uploaded"
          className="h-36 w-full object-cover"
        />
      )}
      <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between bg-gray-200 p-2">
        <button
          onClick={() => onAddCaption(index)}
          className={`flex h-8 w-8 items-center justify-center rounded-full text-white transition-colors hover:bg-opacity-80
            ${imageObj?.description ? "bg-green-500" : "bg-blue-500"}`}
          aria-label="description"
        >
          <i className="fa fa-edit" />
        </button>
        <button
          onClick={() => onDelete(imageObj)}
          className="flex h-8 w-8 items-center justify-center rounded-full bg-red-500 text-white transition-colors hover:bg-opacity-80"
          aria-label="delete"
        >
          <i className="fa fa-trash-alt" />
        </button>
      </div>
      <p className="mt-2 text-center text-sm">
        Description : {imageObj?.description}
      </p>
    </div>
  );
};

const ImageDropzone = (props) => {
  const { imagesMultiple, onChange, getValues, setValue } = props || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [message, setMessage] = useState("");

  const blobToFile = (blob, fileName) => {
    return new File([blob], fileName, { type: blob.type });
  };

  const resizeImage = (file) => {
    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1200,
        1200,
        "JPEG",
        80,
        0,
        async (uri) => {
          const resizedFile = blobToFile(uri, file.name);
          resolve(resizedFile);
        },
        "blob"
      );
    });
  };

  const onDrop = useCallback(
    async (acceptedFiles) => {
      const invalidFiles = [];
      const validImages = [];

      await Promise.all(
        acceptedFiles.map(async (file) => {
          const fileSizeInMB = file.size / (1024 * 1024);
          if (fileSizeInMB > 30) {
            invalidFiles.push({
              name: file.name,
              error: "File size exceeds 30MB",
            });
            return;
          }

          const image = new Image();
          const fileURL = URL.createObjectURL(file);
          image.src = fileURL;

          await new Promise((resolve) => {
            image.onload = () => {
              if (image.width < 100 || image.height < 100) {
                invalidFiles.push({
                  name: file.name,
                  error: "Image dimensions are smaller than 1440x900px",
                });
              } else {
                validImages.push(file);
              }
              resolve();
            };
          });
        })
      );

      if (invalidFiles.length > 0) {
        invalidFiles.forEach((file) => {
          setMessage(<></>);
          setIsModalError(true);
        });
      }

      const newImages = await Promise.all(
        validImages.map(async (file) => {
          const resizedImage = await resizeImage(file);
          if (!(resizedImage instanceof File)) {
            console.error(
              "The resized image is not a File instance:",
              resizedImage
            );
            return null;
          }

          const originalSize = (file.size / 1024).toFixed(2);
          const resizedSize = (resizedImage.size / 1024).toFixed(2);

          return {
            file: file,
            description: "-----",
            originalSize,
            resizedSize,
          };
        })
      );

      // Append new images to existing ones
      const updatedImages = [
        ...(imagesMultiple || []),
        ...newImages.filter(Boolean),
      ];
      onChange(updatedImages);
    },
    [imagesMultiple, onChange]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept: "image/*",
    noClick: true,
    multiple: true,
  });

  const handleDragStart = (index) => setDraggedIndex(index);

  const handleDragEnter = (index) => {
    if (draggedIndex !== null && draggedIndex !== index) {
      const updatedImages = [...imagesMultiple];
      const [draggedImage] = updatedImages.splice(draggedIndex, 1);
      updatedImages.splice(index, 0, draggedImage);
      setDraggedIndex(index);
      onChange(updatedImages);
    }
  };

  const handleDragEnd = () => setDraggedIndex(null);

  const handleDelete = (imageObjToRemove) => {
    const updatedImages = imagesMultiple.filter(
      (imageObj) => imageObj !== imageObjToRemove
    );
    onChange(updatedImages, imageObjToRemove);
  };

  const handleAddCaption = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const handleCaptionChange = (e) => {
    const updatedCaption = e.target.value;
    const updatedImages = imagesMultiple.map((imgObj, index) =>
      index === currentIndex
        ? { ...imgObj, description: updatedCaption }
        : imgObj
    );
    onChange(updatedImages);
  };

  const handleSaveCaption = () => {
    if (currentIndex !== null) {
      const updatedCaption = imagesMultiple[currentIndex].description;
      const currentDescriptions = getValues("imgDescription") || [];

      // Ensure descriptions array has a slot for this image
      while (currentDescriptions.length <= currentIndex) {
        currentDescriptions.push("");
      }

      const newDescriptions = [...currentDescriptions];
      newDescriptions[currentIndex] = updatedCaption;
      setValue("imgDescription", newDescriptions);
    }
    setIsModalOpen(false);
    setCurrentIndex(null);
  };

  return (
    <>
      <div
        {...getRootProps()}
        className="cursor-pointer rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 p-6 text-center"
        onClick={open}
      >
        <input {...getInputProps()} />
        <p className="w-full text-center">
          PLEASE BE PATIENT WHILE YOUR PHOTOS UPLOAD :) <br />
          Drag and drop the images to customize the gallery order.
          <br />
        </p>
      </div>
      {imagesMultiple?.length > 0 && (
        <div className="mt-4 max-h-[400px] overflow-auto rounded-md border border-gray-300 p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {imagesMultiple?.map((imageObj, index) => (
              <SortableItem
                key={index}
                index={index}
                imageObj={imageObj}
                onDelete={handleDelete}
                onAddCaption={handleAddCaption}
                onDragStart={handleDragStart}
                onDragEnter={handleDragEnter}
                onDragEnd={handleDragEnd}
              />
            ))}
          </div>
        </div>
      )}
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${
          isModalOpen ? "" : "hidden"
        }`}
      >
        <div className="w-full max-w-md rounded-lg bg-white p-4 shadow-xl">
          <p className="mb-2 text-lg font-semibold">Add Caption</p>
          <input
            type="text"
            className="w-full rounded-md border border-gray-300 p-3"
            value={imagesMultiple?.[currentIndex]?.description || ""}
            onChange={handleCaptionChange}
          />
          <button
            type="button"
            onClick={handleSaveCaption}
            className="mt-2 w-full rounded-md bg-blue-500 py-2 text-white hover:bg-blue-600"
          >
            Save
          </button>
        </div>
      </div>

      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${
          isModalError ? "" : "hidden"
        }`}
      >
        <div className="w-full max-w-sm rounded-lg bg-white p-4 text-center shadow-xl">
          {message}
          <button
            type="button"
            onClick={() => setIsModalError(false)}
            className="mt-2 w-full rounded-md bg-blue-500 py-2 text-white hover:bg-blue-600"
          >
            Okay
          </button>
        </div>
      </div>
    </>
  );
};

export default ImageDropzone;
